import { useState } from "react";
import { useUsers } from "../api/users";
import "./distributors-panel.css";

export const DistributorsPanel = (): JSX.Element => {
    const [search, setSearch] = useState("");
    const { data: users = [], isLoading, error } = useUsers({
        search: search || undefined,
    });

    if (error) {
        return (
            <div className="distributors-panel">
                <h2>Distributörer</h2>
                <p className="error-message">Kunde inte ladda distributörer.</p>
            </div>
        );
    }

    return (
        <section className="distributors-panel" aria-label="Distributörer">
            <h2>Distributörer</h2>
            <div className="distributors-panel__search">
                <input
                    type="text"
                    placeholder="Sök distributörer..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="search-input"
                    aria-label="Sök distributörer"
                />
            </div>
            {isLoading ? (
                <p>Laddar...</p>
            ) : (
                <div className="distributors-panel__list">
                    {users.length === 0 ? (
                        <p>Inga distributörer hittades.</p>
                    ) : (
                        <table className="distributors-table">
                            <thead>
                                <tr>
                                    <th>Användarnamn</th>
                                    <th>E-post</th>
                                    <th>Team</th>
                                    <th>Senaste inloggning</th>
                                </tr>
                            </thead>
                            <tbody>
                                {users.map((user) => (
                                    <tr key={user.id}>
                                        <td>{user.userName}</td>
                                        <td>{user.email}</td>
                                        <td>{user.primaryTeamName || "-"}</td>
                                        <td>
                                            {user.lastLoginAt
                                                ? new Date(user.lastLoginAt).toLocaleDateString("sv-SE")
                                                : "-"}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            )}
        </section>
    );
};